import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import ImageComponent from 'next/image';
export var StyledImage = /*#__PURE__*/_styled(ImageComponent, true ? {
  target: "eulst6f0"
} : {
  target: "eulst6f0",
  label: "StyledImage"
})(true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL2NvbXBvbmVudHMvSW1hZ2UvSW1hZ2Uudmlld3MudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdpRCIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9jb21wb25lbnRzL0ltYWdlL0ltYWdlLnZpZXdzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IEltYWdlQ29tcG9uZW50IGZyb20gJ25leHQvaW1hZ2UnXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJbWFnZSA9IHN0eWxlZChJbWFnZUNvbXBvbmVudClgXG4gIGhlaWdodDogYXV0bztcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBtYXJnaW46IDAgYXV0bztcbiAgZGlzcGxheTogYmxvY2s7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});